import React from "react";
import InnerBanner from "./../InnerBanner"
import "./PrivacyPolicy.css";

const PrivacyPolicy = (props) => {
    return (
        <React.Fragment>
            <InnerBanner data="Privacy Policy" />
            <div className="container">
                <div className="about-main">
                    <div className="row">
                        <div className="col-lg-12">
                            <p>When you visit our website KTINST.COM, Kalinga Testing Instruments Pvt Ltd Pvt. Ltd. (KTI) may obtain information about you. This Privacy Statement explains how KTI gathers and uses any such information.</p>
                            <p>You are under no obligation to provide any personal information to KTI. If you don't provide such information, some features of KTINST.COM website may not be available to you.</p>
                            <p>KTI collects certain types of information whenever you interact with us. For example, KTI uses "cookies", and obtains certain types of information when your Web browser accesses KTINST.COM website. We also receive and store any information you enter on a KTINST.COM website or give to KTI in any other way.</p>
                            <p>KTI may request and/or collect certain personal information from you; for example your name, email address, phone number etc as well as information related to customer satisfaction surveys, warranty information and/or other purchasing information or other information volunteered by you. KTI may also collect other technical information such as your IP address, MAC address, internet service provider, computer operating platform, web browser, and other similar information.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="about-main">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <h2>How does KTI use the information shared?</h2>
                            </div>
                            <p>Personalizing your experience and interest at our website;</p>
                            <p>Sending you information and offer of our products that may be of your interest;</p>
                            <p>Contacting you for warranty, product, service and sales issues; </p>
                            <p>Automatic monitoring of statistical information to determine how KTINST.COM website is being used.</p>
                            <p>In addition to the above, KTI will provide your personal information to the extent required in, or in connection with, any legal proceeding. KTI also releases account and other personal information when we believe such release is appropriate in conjunction with KTI website Terms of Use and other agreements or to protect the rights, property or safety of KTI website, our users or others. This includes exchanging information with others for fraud protection and credit risk reduction.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="about-main">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <h2>Does KTI share the collected information with third parties?</h2>
                            </div>
                            <p>We do not sell your personal information to third parties. KTI may share personal information with business partners in order to improve your experience with us and for our marketing purposes. KTI may share non-personal aggregate data about sales, customers, visitors to the site and related site information with third parties.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="about-main">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <h2>Does KTI own the shared information?</h2>
                            </div>
                            <p>All opinions, ideas, suggestions, and other information submitted to, or learned of, at KTI website may be used by us, without any restriction and free of charge, and nothing contained in this policy shall limit or otherwise affect this.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="about-main">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <h2>What about KTINST.COM links to other sites?</h2>
                            </div>
                            <p>KTINST.COM website may contain links to other websites. KTI is not responsible for the content that may be on such linked websites or the manner in which such websites obtain or use your personal information.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="about-main">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <h2>Consent</h2>
                            </div>
                            <p>By using the KTINST.COM website, you signify your agreement to the terms and conditions of this Privacy Statement. If you do not agree to these terms and conditions, please do not disclose any individual identifying information through a KTINST.COM website.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="about-main">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <h2>Will this Privacy Policy change?</h2>
                            </div>
                            <p>KTI may change the privacy policy from time to time and such changes will be posted on website, so please review this policy periodically. Your continued use of KTINST.COM website following the posting of all changes to this statement shall mean that you have accepted those changes.</p>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
export default PrivacyPolicy;